/**
 * @name: window
 * @description: 互动服务窗配置
 * @author: qq2575896094
 * @time: 2024/8/13
 */

const prefix = '/onlinecs/window'

/**
 * 查询互动服务窗配置列表
 * @type {string}
 */
export const queryInteractiveWindowConfigList = `${prefix}/queryInteractiveWindowConfigList`

/**
 * 新增互动服务窗配置
 * @type {string}
 */
export const addInteractiveWindowConfig = `${prefix}/addInteractiveWindowConfig`

/**
 * 修改互动服务窗
 * @type {string}
 */
export const modifyInteractiveWindowConfig = `${prefix}/modifyInteractiveWindowConfig`

/**
 * 删除互动服务窗
 * @type {string}
 */
export const removeInteractiveWindowConfig = `${prefix}/removeInteractiveWindowConfig`

/**
 * 互动服务窗排序
 * @type {string}
 */
export const moveInteractiveWindowConfig = `${prefix}/moveInteractiveWindowConfig`
